// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AG8BQ","label":"styles_label__699fJ","textarea":"styles_textarea__cf6oa","count":"styles_count__Osb0q","error":"styles_error__PHskm"};